import { ThemeProvider } from "./theme-provider";
import { TAppProvidesr } from "../types/public";
import { Provider } from "react-redux";
import store from "@/context/store";
import GraphqlProvider from "@/graphql/GraphqlProvider";
import { LivekitContextProvider } from "@/context/features/livekit/LivekitRoomContext";

const AppProvider = ({ children }: TAppProvidesr) => {
  return (
    <Provider store={store}>
      <GraphqlProvider>
        <LivekitContextProvider>
          <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            {children}
          </ThemeProvider>
        </LivekitContextProvider>
      </GraphqlProvider>
    </Provider>
  );
};

export default AppProvider;
